module.exports = __webpack_public_path__ + "img/product6.d3b883f7.png";